import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next'; // 1. ייבוא ה-hook של התרגום
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { Button } from "../components/ui/button";
import { Mail, MessageSquare, Send } from "lucide-react";
import { toast } from '../components/ui/use-toast';
import axios from 'axios';

export default function ContactPage() {
    const { t } = useTranslation(); // 2. הפעלת ה-hook כדי לקבל את פונקציית התרגום t

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        // 3. תרגום הודעות השגיאה (toasts)
        if (!name || !email || !message) {
            toast({
                variant: "destructive",
                title: t('toast.error_title'),
                description: t('toast.fill_all_fields_desc') // נצטרך להוסיף את המפתח הזה ל-JSON
            });
            return;
        }

        setIsSubmitting(true);
        try {
            await axios.post(`${process.env.REACT_APP_API_URL}/contact`, {
                name, email, subject, message
            });

            toast({
                title: t('toast.message_sent_success_title'), // מפתח חדש
                description: t('toast.message_sent_success_desc'), // מפתח חדש
            });

            setName('');
            setEmail('');
            setSubject('');
            setMessage('');

        } catch (error) {
            console.error('Error:', error);
            toast({
                variant: "destructive",
                title: t('toast.message_sent_error_title'), // מפתח חדש
                description: error.response?.data?.message || t('toast.generic_error_desc')
            });
        }
        setIsSubmitting(false);
    };

    return (
        <div className="container mx-auto px-4 py-12">
            <div className="max-w-4xl mx-auto">
                <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="mb-12 text-center">
                    {/* 4. תרגום הטקסטים הראשיים */}
                    <h1 className="text-4xl font-bold text-[#232946] mb-4">{t('pages.contact.title')}</h1>
                    <p className="text-lg text-[#8890b3]">{t('pages.contact.subtitle')}</p>
                </motion.div>

                <div className="grid md:grid-cols-2 gap-12">
                    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }}>
                        <div className="bg-white shadow-md rounded-2xl p-8">
                            <h2 className="text-2xl font-bold mb-6 text-[#232946]">{t('pages.contact.form_title')}</h2>

                            <form onSubmit={handleSubmit} className="space-y-4">
                                {/* 5. תרגום כל ה-placeholders בטופס */}
                                <div>
                                    <Input type="text" placeholder={t('forms.name_placeholder')} value={name} onChange={(e) => setName(e.target.value)} required />
                                </div>
                                <div>
                                    <Input type="email" placeholder={t('forms.email_placeholder')} value={email} onChange={(e) => setEmail(e.target.value)} required />
                                </div>
                                <div>
                                    <Input type="text" placeholder={t('pages.contact.subject_placeholder')} value={subject} onChange={(e) => setSubject(e.target.value)} />
                                </div>
                                <div>
                                    <Textarea placeholder={t('pages.contact.message_placeholder')} value={message} onChange={(e) => setMessage(e.target.value)} required rows={6} />
                                </div>
                                <Button type="submit" disabled={isSubmitting} className="w-full bg-[#232946] text-white hover:bg-[#121629]">
                                    {/* 6. תרגום הטקסטים בכפתור */}
                                    {isSubmitting ? (
                                        <span className="flex items-center">
                                            <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" /*...*/ ></svg>
                                            {t('pages.contact.submitting_button')}
                                        </span>
                                    ) : (
                                        <span className="flex items-center">
                                            <Send className="w-4 h-4 ml-2" />
                                            {t('pages.contact.submit_button')}
                                        </span>
                                    )}
                                </Button>
                            </form>
                        </div>
                    </motion.div>

                    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }}>
                        <div className="bg-[#232946] text-white rounded-2xl p-8 h-full flex flex-col">
                            <h2 className="text-2xl font-bold mb-6">{t('pages.contact.info_title')}</h2>
                            <div className="space-y-8 flex-1">
                                <div className="flex items-start gap-4">
                                    <div className="bg-white/10 p-3 rounded-lg"><Mail className="w-6 h-6" /></div>
                                    <div>
                                        <h3 className="font-medium mb-1">{t('pages.contact.email_title')}</h3>
                                        <a href="mailto:koretigar@koretigar.com" className="text-[#b8c1ec] hover:text-[#eebbc3] transition-colors">koretigar@koretigar.com</a>
                                    </div>
                                </div>
                                <div className="flex items-start gap-4">
                                    <div className="bg-white/10 p-3 rounded-lg"><MessageSquare className="w-6 h-6" /></div>
                                    <div>
                                        <h3 className="font-medium mb-1">{t('pages.contact.social_title')}</h3>
                                        <ul className="space-y-2 text-[#b8c1ec]">
                                            <li><a href="https://linkedin.com/in/leahgolub" target="_blank" rel="noopener noreferrer" className="hover:text-[#eebbc3] transition-colors">LinkedIn</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-auto pt-8">
                                <p className="text-[#b8c1ec]">{t('pages.contact.closing_text')}</p>
                            </div>
                        </div>
                    </motion.div>
                </div>
            </div>
        </div>
    );
}